class RequestError extends Error {
  constructor(message, status = 500, data, requestOpts = {}) {
    super(message)
    this.data = data
    this.status = status
    this.isRequestError = true
    this.requestOpts = requestOpts
  }
}

export default RequestError
